// extracted by mini-css-extract-plugin
export var indeterminate = "_70-5";
export var md = "_70-4";
export var semantic = "_70-6";
export var sm = "_70-3";
export var text = "_70-7";
export var toggleInput = "_70-0";
export var toggleSwitch = "_70-1";
export var xs = "_70-2";